import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

interface BlockState {
  blockCategory: string[];
  loading: boolean;
  error: string | null;
}

const initialState: BlockState = {
  blockCategory: [],
  loading: false,
  error: null,
};

export const getBlockCategories = createAsyncThunk(
  "block/getBlockCategory",
  async (
    { propertyId }: { propertyId: string | undefined },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        `${API_URL}/block/get-by-property-id/${propertyId}`
      );
      return response?.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch block category"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
    }
  }
);

const blockSlice = createSlice({
  name: "block",
  initialState,
  reducers: {
    // add reducers here
    test: (state) => {
      console.log("test");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlockCategories.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getBlockCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.blockCategory = action.payload;
      })
      .addCase(getBlockCategories.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "An error occurred. Please try again.";
      });
  },
});

export const { test } = blockSlice.actions;
export default blockSlice.reducer;
